import { Site } from "@inrange/building-manager-api-client/models-site";
import { useMemo } from "react";
import CollapsibleCard from "../CollapsibleCard";
import { OPERATIONAL_STATUSES } from "../operationalStatusUtils";
import SiteReadingsInvoice from "./SiteReadingsInvoice";
import TransferReadingsInvoice from "./TransferReadingsInvoice";

const SiteBillingOperationalActions = ({ site }: { site: Site }) => {
  const isFixedLease =
    site.tariffConfig.onsitePPA.ppaPurchaseModel === "fixed_lease";

  const hasImportSdmMatch = useMemo(() => {
    return site.sdmMatches.some((match) => match.buyerId === site.id);
  }, [site.sdmMatches, site.id]);

  const isProcureOnlyImport =
    site.totalInstalledCapacity === 0 && hasImportSdmMatch;

  if (
    !OPERATIONAL_STATUSES.has(site.operationalStatus) &&
    site.operationalStatus !== "operationalDemo"
  ) {
    return null;
  }

  return (
    <CollapsibleCard
      title="Site billing"
      initialOpen={true}
      className="mt-3"
      isBulkEdit={true}
    >
      <div className="d-flex flex-column gap-3">
        {!isProcureOnlyImport && (
          <SiteReadingsInvoice site={site} isFixedLease={isFixedLease} />
        )}

        {isProcureOnlyImport && <TransferReadingsInvoice site={site} />}
      </div>
    </CollapsibleCard>
  );
};

export default SiteBillingOperationalActions;
